module.exports = __webpack_public_path__ + "img/dr-hab-Jacek-Wojtkieicz.5044bbb3.jpg";